import { NgModule } from "@angular/core";
import { ParagraphComponent } from "./paragraph.component";

@NgModule({
    declarations: [ParagraphComponent],
    imports: [],
    exports: [ParagraphComponent],
})
export class ParagraphModule {}
